<template>
  <div>
    <h2>色のグループ</h2>
    <p class="left">
      春夏秋冬、季節の色はそれぞれ調和がとれています。
    </p>
    <h3>春</h3>
    <p class="left">
      明るく、生き生きした色
    </p>
    <DoughnutChart
      :chartdata="data1"
      :options="options"
    />
    <hr />
    <h3>夏</h3>
    <p class="left">
      さわやかな色
    </p>
    <DoughnutChart
      :chartdata="data2"
      :options="options"
    />
    <hr />
    <h3>秋</h3>
    <p class="left">
      落ち着いた、渋い色
    </p>
    <DoughnutChart
      :chartdata="data3"
      :options="options"
    />
    <hr />
    <h3>冬</h3>
    <p class="left">
      あざやかで、シャープな色
    </p>
    <DoughnutChart
      :chartdata="data4"
      :options="options"
    />
  </div>
</template>

<script>
import DoughnutChart from '../components/DoughnutChart'

export default {
  name: 'FourSeasons',
  components: {
    DoughnutChart
  },
  data() {
    return {
      data1: {
        // 凡例とツールチップに表示するラベル
        labels: ['きいろ', 'オレンジ', 'あか', 'むらさき', 'あお', 'みどり'],
        // 表示するデータ
        datasets: [
          {
            data: [3, 4, 6, 9, 8, 6],
            backgroundColor: ['#fad831', '#f49d00', '#dd443b', '#a165a8', '#0098b9', '#00a15a'],
            borderColor: 'transparent' // 線なし
          }
        ]
      },
      data2: {
        // 凡例とツールチップに表示するラベル
        labels: ['きいろ', 'オレンジ', 'あか', 'むらさき', 'あお', 'みどり'],
        // 表示するデータ
        datasets: [
          {
            data: [3, 4, 6, 9, 8, 6],
            backgroundColor: ['#fbe68f', '#d98ea5', '#ad2e6c', '#b088b5', '#6c9ac5', '#7eccc1'],
            borderColor: 'transparent' // 線なし
          }
        ]
      },
      data3: {
        // 凡例とツールチップに表示するラベル
        labels: ['きいろ', 'オレンジ', 'あか', 'むらさき', 'あお', 'みどり'],
        // 表示するデータ
        datasets: [
          {
            data: [3, 4, 6, 9, 8, 6],
            backgroundColor: ['#b39300', '#ab3d1d', '#a61d39', '#6c4a71', '#005476', '#525b20'],
            borderColor: 'transparent' // 線なし
          }
        ]
      },
      data4: {
        // 凡例とツールチップに表示するラベル
        labels: ['きいろ', 'オレンジ', 'あか', 'むらさき', 'あお', 'みどり'],
        // 表示するデータ
        datasets: [
          {
            data: [3, 4, 6, 9, 8, 6],
            backgroundColor: ['#fbe68f', '#c85096', '#b91f57', '#3e337b', '#1a54a5', '#006664'],
            borderColor: 'transparent' // 線なし
          }
        ]
      },
      options: {
        responsive: false,
        tooltips: {
          enabled: false //ツールチップを表示しない
        },
        legend: {
          // labels非表示
          display: false
        }
      }
    }
  }
}
</script>

<style scoped>
hr {
  width: 70%;
  margin-top: 50px;
}
.left {
  text-align: left;
  width: 90%;
  margin-left: auto;
  margin-right: auto;
}
</style>